"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _luxon = require("luxon");

var _chartUtils = require("../../chartUtils");

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _ChartStyles = require("../ChartStyles");

var _Display = _interopRequireDefault(require("./Display"));

var _Header = _interopRequireDefault(require("./Header"));

var _Interaction = _interopRequireDefault(require("./Interaction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var transformMaxPercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('maxBatteryPercentageState')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'maxBatteryPercentageState'));
});
var transformMinPercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('minBatteryPercentageState')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'minBatteryPercentageState'));
});
var transformAreaPercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  var isValidMaxReading = (0, _chartUtils.isValidReading)('maxBatteryPercentageState');
  var isValidMinReading = (0, _chartUtils.isValidReading)('minBatteryPercentageState');
  return readings.filter(function (r) {
    return isValidMaxReading(r) && isValidMinReading(r);
  }).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'maxBatteryPercentageState', 'minBatteryPercentageState'));
});

var BatteryMinMaxChart = function BatteryMinMaxChart(_ref) {
  var batteryReadings = _ref.batteryReadings,
      isLoading = _ref.isLoading,
      storageProfile = _ref.storageProfile,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO;

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: timeZone
  });

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: timeZone
  });

  var startMillis = viewStartDateTime.toMillis();
  var endMillis = viewEndDateTime.toMillis();
  var maxCoordinates = transformMaxPercentageCoordinates(batteryReadings, timeZone);
  var minCoordinates = transformMinPercentageCoordinates(batteryReadings, timeZone);
  var areaCoordinates = transformAreaPercentageCoordinates(batteryReadings, timeZone);
  var coordinatesGroupedByTime = (0, _RecentPerformanceCrosshair.groupCoordinatesByTime)({
    maxPercentage: maxCoordinates,
    minPercentage: minCoordinates
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    storageProfile: storageProfile
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
    batteryCoordinates: {
      maxCoordinates: maxCoordinates,
      minCoordinates: minCoordinates,
      areaCoordinates: areaCoordinates
    },
    endMillis: endMillis,
    isLoading: isLoading,
    startMillis: startMillis,
    timeZone: timeZone
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    endMillis: endMillis,
    startMillis: startMillis,
    timeZone: timeZone
  }))));
};

BatteryMinMaxChart.propTypes = {
  batteryReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    maxBatteryPercentageState: _propTypes["default"].number,
    minBatteryPercentageState: _propTypes["default"].number,
    timestamp: _propTypes["default"].string
  })),
  isLoading: _propTypes["default"].bool,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }).isRequired,
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired
};
BatteryMinMaxChart.defaultProps = {
  batteryReadings: [],
  isLoading: false,
  timeZone: 'local'
};
var _default = BatteryMinMaxChart;
exports["default"] = _default;